module.exports = __webpack_public_path__ + "9e40472fb3e332042dfd63e37e7ee60d.png";